import StepLabelComponent from './StepLabelComponent';
const MuiStepLabel = {
  StepIconComponent: StepLabelComponent
};
export default MuiStepLabel;